import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Theme } from "@mui/material";
import Card from "@mui/material/Card";
import { URGENCY_DATA } from "fe-web-components/data/urgencyData";
import { MultiLanguageIconContainer } from "../rtl/rtlStyles";

type PatientColorMap = string;
//region [[ Styles ]]

const UrgencyIndicatorView = styled(Card)(({ theme }) => ({
  border: "1px solid #EBEBEB",
  boxShadow: "0px 7px 17px rgba(0, 0, 0, 0.05)",
  borderRadius: "8px",
  marginBottom: "20px",
}));

const UrgencyIcon = styled(MultiLanguageIconContainer)({});

const UrgencyTitle = styled("div")(
  ({
    theme,
    color,
    lightcolor,
  }: {
    theme?: Theme;
    color: PatientColorMap;
    backgroundColor?: PatientColorMap;
    lightcolor?: PatientColorMap;
  }) => ({
    fontSize: "17px",
    color: color,
    borderBottom: "1px solid " + color,
    backgroundColor: lightcolor,
    display: "flex",
    alignItems: "center",
    fontWeight: 700,
    padding: "13px",
  }),
);

const ResultTextBottom = styled("div")(
  ({ theme, bgcolor }: { theme?: Theme; bgcolor: PatientColorMap }) => ({
    fontWeight: 500,
    fontSize: "14px",
    color: "#243443",
    padding: "15px",
    backgroundColor: bgcolor,
    whiteSpace: "break-spaces",
    lineHeight: "22px",
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface UrgencyIndicatorProps {
  urgency: string;
  translate: (id: string) => string;
}

//endregion [[ Props ]]
//endregion [[ Functions ]]

/**
 * @deprecated The method should not be used
 */
export const UrgencyIndicator = ({
  urgency,
  translate,
}: UrgencyIndicatorProps) => {
  const resultText2 = `${urgency ? translate(URGENCY_DATA[urgency].text) : ""}`;

  return (
    <UrgencyIndicatorView className={"urgency-indicator-view"}>
      <UrgencyTitle
        color={URGENCY_DATA[urgency].color}
        lightcolor={URGENCY_DATA[urgency].lightColor}
      >
        <UrgencyIcon>{URGENCY_DATA[urgency].icon}</UrgencyIcon>
        {urgency && <span>{translate(URGENCY_DATA[urgency].title)}</span>}
      </UrgencyTitle>
      <ResultTextBottom bgcolor={URGENCY_DATA[urgency].lightColor}>
        {resultText2}
      </ResultTextBottom>
    </UrgencyIndicatorView>
  );
};
